
import state from './moduleEmotionHackState.js'
import mutations from './moduleEmotionHackMutations.js'
import actions from './moduleEmotionHackActions.js'
import getters from './moduleEmotionHackGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
